import React,{useEffect, useState} from 'react'
import {Container,Row,Col,Button} from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import Swal from 'sweetalert2'
import { getOrigens, removeOrigen } from '../../../actions/origensActions'
import { CustomDataTable } from '../../../components/design/Datatables/CustomDataTable'

export default function Origens() { 
    const { t } = useTranslation()
    const [isLoading, setIsLoading] = useState(true) 
    const {origens, loading, result} = useSelector(state=>state.origens) 
    const dispatch = useDispatch()
    
    useEffect(()=>{
        dispatch(getOrigens())
    }, [dispatch])

    useEffect(()=>{
        setIsLoading(loading)
    }, [loading])

    useEffect(()=>{
        if(result != null){
            if(result !== 'ok'){
                Swal.fire({
                    showConfirmButton: true,
                    confirmButtonText: t('origens.itsok'),
                    icon: 'error',
                    text: t('origens.'+result.message+'0') + result.count + t('origens.'+result.message+'1')
                })
                dispatch({
                    type: 'ORIGEN_RESET_RESULT'
                })
            }else{
                Swal.fire({
                    showConfirmButton: true,
                    confirmButtonText: t('origens.letsok'),
                    icon: 'success',
                    text: t('origens.deletedorigen')
                })
                dispatch({
                    type: 'ORIGEN_RESET_RESULT'
                })
            }
        }
    }, [result, t, dispatch])

    const deleteOrigen = (idOrigen) => {
        Swal.fire({
            title: t('alert.areusure'),
            showDenyButton: true,
            confirmButtonText: t('alert.delete'),
            denyButtonText: t('alert.canceled'),
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(removeOrigen(idOrigen))
                Swal.fire(t('alert.deleted'), '', 'success')
            }
        })
    }

    // Datatables
    const columns = [
        {
            name: t('origens.name'),
            cell: datos =>
                <div>
                    {datos.name}
                </div>,
            selector: (datos) => datos._id,
            sortable: true,
        },{
            name: t('origens.type'),
            cell: datos =>
                <div>
                    {datos.type ? 'Si' : 'No'}
                </div>,
            selector: (datos) => datos._id,
            sortable: true,
        },{
            name: '',
            cell: datos =>
            <>
                <Button variant="outline-info mx-auto" href={`/admin/origen/`+datos._id}>
                    <i className="fas fa-map-marker-alt"></i> <i className="fas fa-edit fa-sm"></i>
                </Button>
                <Button variant="outline-danger mx-auto" onClick={() => deleteOrigen(datos._id)}>
                    <i className="fas fa-map-marker-alt"></i> <i className="fas fa-minus fa-sm"></i>
                </Button>
            </>
        }
    ]
      
    return (
        <>
        {isLoading
        ?      
          <div className='d-flex justify-content-center vh-100'>            
              <span className="spinner-border spinner-border-sm" style={{width: "5rem",height: "5rem"}}></span>
          </div>
        : 
        <>        
            <Container className='cuerpo'>
                <Row className="text-left custom-card-header-list">
                    <Col>
                        <Button className="btn btn-secondary my-2 mx-auto float-right" href={`/admin/dashboard`}>
                            <i className="fas fa-arrow-circle-left"></i> {t('global.return')}
                        </Button>
                        <h1 className='mb-2'>{t('origens.editorigen')}</h1> 
                        <label className='mb-2'>{t('origens.selectorigen')}</label>
                        <Row className="custom-card-buttom">
                            <Button className="btn btn-secondary my-2 mx-auto" href={`/admin/origen`}>
                                <i className="fas fa-map-marker-alt"></i> {t('origens.new')}
                            </Button>
                        </Row>
                        <Row className="text-center justify-content-center">
                            {origens 
                                ?
                                    <CustomDataTable columns={columns} data={origens} />
                                :
                                    <></>
                            }
                        </Row>
                    </Col>
                </Row>
            </Container>
        </>
        }
        </>
    )
}